module.exports = __webpack_public_path__ + "static/19-ef972cb8674d948fc47ee16f61efc338.png";